import { css } from "@emotion/css"

import CertificationMarks from "./CertificationMarks/CertificationMarks"

const FooterBottom = () => {
  return (
    <div className={styles.container}>
      <span className={styles.copyright}>©&nbsp; p-ban.com Corp. All rights reserved.</span>
      <CertificationMarks />
    </div>
  )
}

export default FooterBottom

const styles = {
  container: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    height: 110px;
    padding: 10px;

    background-color: #006e06;
  `,
  copyright: css`
    margin-right: 358px;
    font-size: 11px;
  `,
}
